import React from 'react';
import { useTranslations } from '../../hooks/useTranslations';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
function SportElement({ value, highlights, position }) {
    const { t } = useTranslations();
    let href;
    switch (value.slug) {
        case 'horse-racing':
        case 'greyhounds':
            href = `${value.slug}/meetings`;
            break;
        case 'lotteries':
            href = `apps/${value.slug}`;
            break;
        default:
            href = value.slug;
    }
    const searchSection = 'Sport';
    return (React.createElement(SectionItem, { expectedTitle: 2, expectedDescription: 1, cutDescription: 2, internalLink: true, href: href, id: value.id, searchSection: searchSection, position: position },
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.name, content: value.name })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            React.createElement(Highlight, { highlighted: highlights['name'] && `${highlights['name']} ${t('sportResultHighlight')}`, content: `${value.name} ${t('sportResultHighlight')}` }))));
}
export const SportSection = createListSection(SportElement, {
    title: 'sectionSportsTitle',
});
//# sourceMappingURL=SportSection.js.map